module.exports = __webpack_public_path__ + "static/media/taggis-qr-logo.9dc1ee4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taggis-qr-logo.png
// module id = 375
// module chunks = 3